import {$window, $body} from '../Constants';
import HtmlElement from "./HtmlElement";


/**
 * Selector
 */
const Selector = {
	TABLE_WRAPPER: '.table-wrapper'
};

class ReportTable extends HtmlElement {
	// Public

	onReady() {
		super.onReady();
		this._bindHandlers();
	}

	_bindHandlers() {
		this.$element.find('tr').not(':first-child').on('click', e => {
			$(e.delegateTarget).toggleClass('act');
		});
	}
}

let allTables = [];

$body.find(Selector.TABLE_WRAPPER).each(function() {
	allTables.push(new ReportTable($(this)));
});

export default allTables;
